import React, { Component } from 'react';
import { connect } from "react-redux";
import * as actions from "../actions";
import * as _ from 'lodash';
import { BROADCASTER, getUserDetail } from "../util/account_management";
//image
import loading_blue from '../assets/gif/loading_blue.gif';
import vuepay_large_logo from '../assets/images/vuepaylogonav@5x.png';
//libraries
import IntlTelInput from 'react-intl-tel-input';
import 'react-intl-tel-input/dist/libphonenumber.js';
import 'react-intl-tel-input/dist/main.css';
import { checkForBroadcaster, hideMobileVerification } from "../util/broadcaster/register_util";
import { getData, LOGIN } from "../util/storage";
import { isEmpty, navigate, vuepayAlert } from "../util/utility";

class VerifyMobile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            country_code: '+44',
            mobile_number: '',
            changed_mobile_number: '',
            mobile_number_error: false,
            mobile_number_valid: false,
            mode: 'mobile_number_verification'
        };
        this.handleKeyUp = this.keyUpHandler.bind(this, 'LoginInput');
        this.setMode = this.setMode.bind(this);
        this.mobileNumberChange = this.mobileNumberChange.bind(this);
        this.hideMobileVerification = this.hideMobileVerification.bind(this);

        this.verifyOTP = this.verifyOTP.bind(this);
        this.resendOTP = this.resendOTP.bind(this);
        this.changeMobileNumber = this.changeMobileNumber.bind(this);
    }

    /**
     * This is invoked when an update is caused by changes to props or state.
     * These methods are called when a component is being re-rendered
     * @param nextProps
     */
    UNSAFE_componentWillReceiveProps(nextProps) {

        if (checkForBroadcaster(nextProps, "verify_otp")) {
            //user is requesting to verify their mobile number with us as a broadcaster
            if (nextProps.broadcaster.verify_otp.payload.status_code === 200) {
                //response received from the server was 200 i.e. user is successfully verified their number

                //show a success message
                hideMobileVerification()
                vuepayAlert("success", nextProps.broadcaster.verify_otp.payload.message, () => {
                    //update the props to reset the registration details using the action (resetBroadcastRegister)
                    nextProps.resetVerifyOTP();
                    //since the request for verify mobile number was accepted by the webservice
                    //navigate the user to broadcaster create profile
                    navigate(this.props, "broadcaster_create_profile");
                });
            } else {
                //show a error message
                vuepayAlert("error", nextProps.broadcaster.verify_otp.payload.message, () => {
                    //update the props to reset the registration details using the action (resetBroadcastRegister)
                    nextProps.resetVerifyOTP();
                });
            }
        }

        if (checkForBroadcaster(nextProps, "resend_otp")) {
            //user is requesting to resend their otp
            if (nextProps.broadcaster.resend_otp.payload.status_code === 200) {
                //response received from the server was 200 i.e. webservice has given us go ahead
                //show a success message
                vuepayAlert("success", nextProps.broadcaster.resend_otp.payload.message, () => {
                    //update the props to reset the registration details using the action (resetBroadcastRegister)
                    nextProps.resetResentOTP();
                });
            } else {
                //show a error message
                vuepayAlert("error", nextProps.broadcaster.resend_otp.payload.message, () => {
                    //update the props to reset the registration details using the action (resetBroadcastRegister)
                    nextProps.resetResentOTP();
                    // this.hideMobileVerification()
                });
            }
        }

        if (checkForBroadcaster(nextProps, "change_mobile_number")) {
            //user has requested to change their mobile number
            if (nextProps.broadcaster.change_mobile_number.payload.status_code === 200) {
                //response received from the server was 200 i.e. user has successfully changed their number
                //show a success message
                vuepayAlert("success", nextProps.broadcaster.change_mobile_number.payload.change_number, () => {
                    //update the props to reset the registration details using the action (resetBroadcastRegister)
                    this.setState({
                        changed_mobile_number: nextProps.broadcaster.change_mobile_number.payload.mobile_number
                    });
                    nextProps.resetChangeMobileNumber();
                    //since the request for change mobile number was accepted by the webservice
                    //navigate the user to mobile_number_verification part
                    this.setMode("mobile_number_verification")
                });
            } else {
                //show a error message
                vuepayAlert("error", nextProps.broadcaster.change_mobile_number.payload.message, () => {
                    //update the props to reset the registration details using the action (resetBroadcastRegister)
                    nextProps.resetChangeMobileNumber();
                });
            }
        }
    }

    verifyOTP() {
        if (!this.props.broadcaster.verify_otp.isFetching) {
            let otp_number = [
                document.getElementById("otp-number-1").value,
                document.getElementById("otp-number-2").value,
                document.getElementById("otp-number-3").value,
                document.getElementById("otp-number-4").value,
                document.getElementById("otp-number-5").value
            ], otp = '';

            _.map(otp_number, (value) => {
                otp = `${otp}${value}`
            });

            //otp length has to be five digit
            if (otp.length === 5) {

                //get user data locally from the storage
                getData(LOGIN)
                    .then((data) => {
                        if (!isEmpty(data)) {
                            //dispatch an action (verifyOTP)
                            this.props.verifyOTP(data.token, data.api_token, {
                                device: this.props.device,
                                otp: otp
                            });
                        }
                    })
            }
        }
    }

    resendOTP() {
        if (!this.props.broadcaster.resend_otp.isFetching) {
            //get user data locally from the storage
            getData(LOGIN)
                .then((data) => {
                    if (!isEmpty(data)) {
                        //dispatch an action (broadcastRegister)
                        this.props.resentOTP(data.token, data.api_token, {
                            device: this.props.device
                        });
                    }
                })
        }
    }

    changeMobileNumber() {
        if (!this.props.broadcaster.change_mobile_number.isFetching) {
            if (this.state.mobile_number_valid) {
                //get user data locally from the storage
                getData(LOGIN)
                    .then((data) => {
                        if (!isEmpty(data)) {
                            //dispatch an action (broadcastRegister)
                            this.props.changeMobileNumber(data.token, data.api_token, {
                                device: this.props.device,
                                country_code: this.state.country_code,
                                mobile_number: this.state.mobile_number
                            });
                        }
                    })
            }
        }
    }

    hideMobileVerification() {
        // this.props.history.push("/dashboard");
        hideMobileVerification();
    };

    setMode(mode) {
        this.setState({
            mode: mode
        })
    };

    /**
     * listener for mobile number change we use this to validate if the mobile number is valid as per the country policy
     * @param status
     * @param value
     * @param countryData
     * @param number
     * @param id
     */
    mobileNumberChange = (status, value, countryData, number, id) => {

        if (status) {
            this.setState({
                country_code: "+" + countryData.dialCode,
                mobile_number: value,
                mobile_number_error: false,
                mobile_number_valid: true,
            });
        } else {
            this.setState({
                mobile_number_error: true,
                mobile_number_valid: false
            });
        }
    };

    /**
     * listener for OTP
     * @param refName
     * @param e
     */
    keyUpHandler(refName, e) {
        const target = e.srcElement || e.target;
        const maxLength = 1//target.attributes["maxLength"].value;
        const myLength = target.value.length;
        const attribute = parseInt(target.attributes.getNamedItem('data-field').value);

        if (myLength >= maxLength) {
            if (attribute !== 5) {
                document.getElementById("otp-number-" + (attribute + 1)).focus()
            }
        } else if (myLength === 0) {
            // Move to previous field if empty (user pressed backspace)
            if (attribute !== 1) {
                document.getElementById("otp-number-" + (attribute - 1)).focus()
            }
        }
    }

    render() {

        return (
            <div id="mobile-verification-modal" className="modal fade" role="dialog" aria-labelledby="myModalLabel"
            aria-hidden="true">
                <main role="main" className="">
                    <div className="login-container">
                        <div className="popup-header">
                            <button type="button"
                                className="close"
                                data-dismiss="modal"
                                aria-label="Close"
                                onClick={() => {
                                    hideMobileVerification();
                                    document.getElementsByClassName("modal-overlay")[0].style.display = "block";
                                }}
                            >
                                <img alt={"close-icon"}
                                    src={"https://s3.eu-west-2.amazonaws.com/assets.vuepay.com/close.svg"} />
                            </button>
                        </div>
                        <div>
                            <div className="">
                                <div className="row">
                                    <div className="col-md-6 bg-primary d-flex align-items-center text-center"
                                        style={{ borderRight: '1px solid #e7e7e7' }}>
                                        <img src={vuepay_large_logo} className="img-fluid" alt={"VuePay logo"} />
                                    </div>
                                    <div className="col-md-6 bg-white d-flex align-items-center">
                                        <div style={{width:'100%', margin:'0 auto'}}>
                                            <div className="modal-body">
                                                <h4 className="mb-4" style={{textAlign:"center"}}>Mobile number verification</h4>
                                                {
                                                    this.state.changed_mobile_number.length > 0
                                                        ?
                                                        <p style={{textAlign:"center"}}>We have sent a code
                                                        to {this.state.changed_mobile_number} please
                                                        enter it below
                                                        <a href="#" title="change mobile number" onClick={() => {
                                                                this.setMode("change_mobile_number")
                                                            }}>(change mobile
                                                            number)</a></p>
                                                        :
                                                        <p style={{textAlign:"center"}}>We have sent a code
                                                        to {getUserDetail(this.props, BROADCASTER, "country_code")} {getUserDetail(this.props, BROADCASTER, "phone_number")} please
                                                        enter it below
                                                        {/* <a href="#" title="change mobile number" onClick={() => {
                                                            this.setMode("change_mobile_number")
                                                        }}>(change mobile
                                                            number)</a> */}
                                                        </p>
                                                }
                                                <ul className="otp-verify" onKeyUp={this.handleKeyUp} ref="LoginInput">
                                                    <li><input className="otp-number" id="otp-number-1" data-field="1"
                                                        type="number" maxLength="1" /></li>
                                                    <li><input className="otp-number" id="otp-number-2" data-field="2"
                                                        type="number" maxLength="1" /></li>
                                                    <li><input className="otp-number" id="otp-number-3" data-field="3"
                                                        type="number" maxLength="1" /></li>
                                                    <li><input className="otp-number" id="otp-number-4" data-field="4"
                                                        type="number" maxLength="1" /></li>
                                                    <li><input className="otp-number" id="otp-number-5" data-field="5"
                                                        type="tel" maxLength="1" /></li>
                                                </ul>
                                            </div>
                                            <div className="mt-4 text-center">
                                                <button type="button" className="btn btn-outline-primary"
                                                    onClick={this.verifyOTP}>
                                                    {
                                                        this.props.broadcaster.verify_otp.isFetching
                                                            ?
                                                            <img src={loading_blue} alt={"Loading"} width={26} height={26} />
                                                            :
                                                            'Submit'
                                                    }
                                                </button>
                                            </div>
                                            <div className="mt-4 text-center">
                                                <button type="button" className="btn btn-link" data-dismiss="modal"
                                                    onClick={this.resendOTP}>
                                                    {
                                                        this.props.broadcaster.resend_otp.isFetching
                                                            ?
                                                            <img src={loading_blue} alt={"Loading"} width={26} height={26} />
                                                            :
                                                            'Re-send code'
                                                    }
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* {
                                (this.state.mode === "mobile_number_verification")
                                    ? null
                                    :
                                    <div>
                                        <div className="modal-body">
                                            <h4 className="mb-4">Change mobile number</h4>
                                            <p>Enter your mobile number to set up two factor authentication<br/>
                                                <a href="#"
                                                   title="back to verify mobile"
                                                   onClick={() => {
                                                       this.setMode("mobile_number_verification")
                                                   }}>(back
                                                    to verify mobile)</a></p>
                                            <div className="form-group">
                                                <div className="input-group"
                                                     style={{height: 47, display: 'flex', justifyContent: 'center'}}>
                                                    <IntlTelInput
                                                        onPhoneNumberChange={this.mobileNumberChange}
                                                        onPhoneNumberBlur={this.mobileNumberChange}
                                                        preferredCountries={['gb']}
                                                        css={['intl-tel-input', 'form-control form-control-tel']}
                                                        utilsScript={'libphonenumber.js'}
                                                    />
                                                </div>
                                                {
                                                    this.state.mobile_number_error &&
                                                    <p className="text-danger">Please enter valid mobile number.</p>
                                                }
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-outline-primary"
                                                    onClick={this.changeMobileNumber}>
                                                {
                                                    this.props.broadcaster.change_mobile_number.isFetching
                                                        ?
                                                        <img src={loading_blue} alt={"Loading"} width={26} height={26}/>
                                                        :
                                                        'Save'
                                                }
                                            </button>
                                        </div>
                                    </div>
                            } */}
                    </div>
                </main>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        account_management: state.account_management,
        device: state.device.payload,
        broadcaster: {
            verify_otp: state.broadcaster_verify_otp,
            resend_otp: state.broadcaster_resend_otp,
            change_mobile_number: state.broadcaster_change_mobile_number
        },
    };
}

export default connect(mapStateToProps, actions)(VerifyMobile);